import { DateTime as DT } from 'luxon';
import { Button, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import EToolTip from 'components/others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';
import ClientAction from './ClientsRows/ClientAction';
import ClientNameItem from './ClientsRows/ClientNameItem';
import type { NewSaleType } from 'modules/objects';
import type { NewObjectType } from 'modules/lead';
import { getLocale } from 'utils/helpers/functions/getLocale';
import { useClients } from './context/ClientsProvider';

interface ClientTableRowProps {
    client: any;
    fetchClients: (force?: boolean) => Promise<void>;
    setEditClientId: (clientId: number) => void;
    setInfoClientId: (clientId: number) => void;
    setSubjectsClientId: (clientId: number) => void;
    onCreateSale?: (sale: NewSaleType) => void;
    onCreateObject?: (object: NewObjectType) => void;
}

const ClientTableRow = ({ client, fetchClients, setEditClientId, setInfoClientId, setSubjectsClientId, onCreateSale, onCreateObject }: ClientTableRowProps) => {
    const { t, i18n } = useTranslation(['Clients']);
    const { showEmail, showStatus, showCreated } = useClients();
    const dtC = DT.fromMillis(client?.clientCreated || 0)
        .setLocale(getLocale(i18n.language))
        .toLocaleString(DT.DATE_MED);

    return (
        <tr>
            <td className="name">
                <Col>
                    <ClientNameItem client={client} onClick={setEditClientId} />
                </Col>
            </td>
            {showEmail ? (
                <td className="email text-break">
                    <CopyTextWrapper value={client.clientEmail || ''} wrap>
                        <span>{client.clientEmail || '-'}</span>
                    </CopyTextWrapper>
                </td>
            ) : null}
            {showStatus ? (
                <td className="status">
                    <span className={`badge ${client.clientStatus === 0 ? 'bg-success' : 'bg-secondary'}`}>
                        {client.clientStatus === 0 ? t('status.0') : t('status.1')}
                    </span>
                </td>
            ) : null}
            <td className="leads-count">{client.leadsCount || 0}</td>
            {showCreated ? <td className="updated">{dtC}</td> : null}
            <td className="action">
                <div className="d-flex align-items-center justify-content-end gap-1">
                    <EToolTip title={t('clientPopup.subjects')}>
                        <span className="d-inline-block">
                            <Button
                                className="p-1 py-0"
                                size="sm"
                                variant="light-secondary"
                                onClick={(e) => {
                                    e.currentTarget.blur();
                                    setSubjectsClientId(client.ID);
                                }}
                            >
                                <SolarIcon name="person-vcard" />
                            </Button>
                        </span>
                    </EToolTip>
                    <ClientAction
                        client={client}
                        fetchClients={fetchClients}
                        setEditClientId={setEditClientId}
                        setInfoClientId={setInfoClientId}
                        setSubjectsClientId={setSubjectsClientId}
                        onCreateSale={onCreateSale}
                        onCreateObject={onCreateObject}
                    />
                </div>
            </td>
        </tr>
    );
};

export default ClientTableRow;
